var Presentation = function() {
	this.currentPageId = 0;
	this.pageIds = [];
	this.pageMetadata = [];
	this.animationTrigger = false;
	this.loadEvents();

	this.getPageId = function(fromPageId, previousOrNext) {
		var previousPageId     = false;
		var currentPageIdFound = false;
		var returnPageId       = false;

		$.each(this.pageIds, (key, pageId) => {
			if (currentPageIdFound && previousOrNext === 'next') {
				returnPageId = pageId;
				return false;
			}

			if (pageId === fromPageId) {
				currentPageIdFound = true;

				if (previousOrNext === 'previous') {
					returnPageId = previousPageId;
					return false;
				}
			}

			previousPageId = pageId;
		});

		return returnPageId;
	};

	this.getPageIndex = (pageId) => {
		return this.pageIds.indexOf(pageId);
	};

	this.getCurrentIndex = () => {
		return this.getPageIndex(this.currentPageId);
	};

	this.getPageMetadata = function(pageId, key) {
		var data = this.pageMetadata[pageId] || {};
		return data[key] || false;
	}
};

Presentation.prototype.setPageIds = function(pageIds, currentPageId, currentPageMetadata) {
	this.pageIds = pageIds;
	this.currentPageId = currentPageId;
	this.pageMetadata[currentPageId] = currentPageMetadata;

	var $currentPage = $('.pages .page[data-page-id="' + currentPageId + '"]');
	$currentPage.addClass('current-page loaded');

	$.each(pageIds, (index, pageId) => {
		var $element = $('<div class="page" data-page-id="' + pageId + '"></div>');

		if (index < this.getCurrentIndex()) {
			$element.insertBefore($currentPage);
		} else if (index > this.getCurrentIndex()) {
			$element.appendTo('.pages');
		}
	});

	this.cleanupPages();

	$('.pages .page').css('transform', 'translateX(-' + (this.getCurrentIndex() * 100) + '%)');

	setTimeout(() => {
		$('.pages').addClass('init');
	}, 300);
};

Presentation.prototype.loadEvents = function() {
	this.$controls = $('.presentation-controls');

	this.$controls.find('.next, .previous').addClass('disabled');

	$('.presentation-toggle').on('click', (e) => {
		e.preventDefault();
		$('html').toggleClass('presentation-started');
		document.cookie = 'presentation=' + (this.isActive() ? 1 : 0) + ';expires=;path=/';
		this.init();
	});

	this.$controls.find('.previous').on('click', (e) => {
		e.preventDefault();
		this.gotoPage('previous');
	});

	this.$controls.find('.next').on('click', (e) => {
		e.preventDefault();
		this.gotoPage('next');
	});

    $(document).on('keyup', (e) => {
		if (!this.isActive()) {
			return;
		}

        if (e.key === 'Escape')     $('.presentation-toggle').trigger('click');
        if (e.key === 'ArrowLeft')  this.$controls.find('.previous').trigger('click');
        if (e.key === 'ArrowRight') this.$controls.find('.next').trigger('click');
    });
};

Presentation.prototype.isActive = function() {
	return $('html').hasClass('presentation-started');
};

Presentation.prototype.init = function() {
	if (!this.isActive()) {
		return false;
	}

	setTimeout(() => {
		this.loadPage('next');
		this.loadPage('previous');
	}, 300);
};

Presentation.prototype.loadPage = function(previousOrNext) {
	var pageId = this.getPageId(this.currentPageId, previousOrNext);

	if (!pageId) {
		// console.log('no ' + previousOrNext + ' page id found from ' + this.currentPageId + ', disabling button');
		this.$controls.find('.' + previousOrNext).addClass('disabled');
	}

	var $page  = $('.pages .page[data-page-id="' + pageId + '"]');

	if ($page.html() === '') {
		this.$controls.find('.' + previousOrNext).addClass('disabled loading');
		// console.log('loading ' + previousOrNext + ' page', pageId, $page);

		$.get('/site/ajax/get_page_content.php?id=' + pageId).done((data) => {
			$page.html(data.html).addClass('loaded');
			$page.find('[data-background], img[data-src]').imageLoader();
			this.$controls.find('.' + previousOrNext).removeClass('disabled loading');
			this.pageMetadata[pageId] = data.metadata;
			// console.log('done loading ' + previousOrNext + ' page');
		}).fail(() => {
			this.$controls.find('.' + previousOrNext).removeClass('loading');
			console.warn('error loading ' + previousOrNext + ' page');
		});
	}
};

Presentation.prototype.gotoPage = function(previousOrNext) {
	// update the current page id
	var pageId = this.getPageId(this.currentPageId, previousOrNext);

	if (!pageId) {
		return false;
	}

	this.currentPageId = pageId;

	// disable buttons
	this.$controls.find('.previous, .next').addClass('disabled');

	// set old pages inactive
	$('.pages .page.current-page').removeClass('current-page');

	// set new page active
	$('.pages .page[data-page-id="' + this.currentPageId + '"]').addClass('current-page');

	this.cleanupPages();

	// update page position and scroll to top
	$('.pages .page').css('transform', 'translateX(-' + (this.getPageIndex(this.currentPageId) * 100) + '%)');
	smoothScrollTo($('body'), 0, 800);

	// start animations
	if (this.animationTrigger) {
		clearTimeout(this.animationTrigger);
	}

	this.animationTrigger = setTimeout(() => {
		$(window).trigger('anim-init');
	}, 400);

	this.animationTrigger = setTimeout(() => {
		$('.pages .page:not(.current-page)').find('.anim-added').removeClass('anim-init anim-added anim-started');
		$(window).trigger('anim-init');
	}, 850);

	// load sibling pages after animation has ended
	// setTimeout(() => {
		var url = this.getPageMetadata(this.currentPageId, 'url') || '';
		if (url) { history.pushState({}, '', url); }
		var title = this.getPageMetadata(this.currentPageId, 'title') || '';
		if (title) { document.title = title; }

		this.$controls.find('.previous, .next').removeClass('disabled');
		this.loadPage(previousOrNext);
	// }, 900);
};

Presentation.prototype.cleanupPages = function() {
	var self = this;
	var currentIndex = self.getCurrentIndex();

	// make sure a maximum of 5 pages will be stored in the dom
	$('.pages .page').each(function() {
		var pageId     = $(this).data('page-id');
		var pageIndex  = self.getPageIndex(pageId);

		if (Math.abs(currentIndex - pageIndex) > 2) {
			// $(this).removeClass('loaded').html('');
		}

		$(this).css('z-index', self.pageIds.length - Math.abs(currentIndex - pageIndex));
	});
};
